import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils/api'
import { fetchDocumentById } from '../query-api'
import type { DmsDocument } from '../types'

interface UseFetchDocumentByIdOptions {
  enabled?: boolean
}

export const useFetchDocumentById = (documentId?: string, { enabled = true }: UseFetchDocumentByIdOptions = {}) => {
  const { organization } = useUserOrganization()

  const { data, error, isError, isLoading } = useQuery<DmsDocument, APIError>(
    [QueryKeys.DmsDocument, organization?.id, documentId],
    () => fetchDocumentById(organization?.id as string, documentId ?? ''),
    {
      enabled: enabled && Boolean(organization?.id) && Boolean(documentId),
      retry: false,
    },
  )

  return {
    document: data,
    error,
    isError,
    isLoading,
  }
}
